import SSContainer from "@core-components/container/Container";
import ReviewLabel from "@core-components/reviews/ReviewLabel";
import { Space, Stack } from "@mantine/core";
import NewsBanner from "./NewsBanner";

const SubHeader = () => {
  return (
    <>
      <Space h={67} />
      <Stack align="end" className="relative z-10" gap={0} visibleFrom="xs">
        <NewsBanner />
        <SSContainer className="relative w-full">
          <div className="absolute right-10 bottom-0 z-50 translate-y-full xl:right-0">
            <ReviewLabel />
          </div>
        </SSContainer>
      </Stack>
    </>
  );
};

export default SubHeader;
